import { Box } from '@mui/material';
import { GradientScale } from '../../GradientScale/GradientScale';
import { PointColorConfiguration } from '../types';

export type PointColorLegendProps = {
  colorConfig: Pick<PointColorConfiguration, 'min' | 'max' | 'color'>;
};

export const PointColorLegend = ({ colorConfig }: PointColorLegendProps) => {
  return (
    <Box sx={{ position: 'absolute', bottom: 8, right: 16, width: '150px' }}>
      <GradientScale
        min={colorConfig.min}
        max={colorConfig.max}
        color={colorConfig.color}
      />
    </Box>
  );
};
